import { View, Text, Platform } from "react-native";
import React, { useRef, useState } from "react";
import VideoItem from "./VideoItem";
import { width } from "../../imports";
import MyText from "../custom/MyText";
import { ResizeMode, Video } from "expo-av";
import MyButton from "../../components/custom/MyButton";
import * as ScreenOrientation from "expo-screen-orientation";
import { useEffect } from "react";

export default function index({ url }) {
  const videoRef = useRef(null);
  const [status, setStatus] = useState({});

  return Platform.OS !== "web" ? (
    <View style={{ width: "100%", marginVertical: 5 }}>
      <Video
        ref={videoRef}
        style={{ width: "100%", height: 280 }}
        source={{
          uri: url,
        }}
        useNativeControls
        resizeMode={ResizeMode.CONTAIN}
        isLooping
        onPlaybackStatusUpdate={(status) => setStatus(() => status)}
        onFullscreenUpdate={(s) => {
          if (+s.fullscreenUpdate === 1) {
            ScreenOrientation.unlockAsync();
          } else if (+s.fullscreenUpdate === 3) {
            ScreenOrientation.lockAsync(
              ScreenOrientation.OrientationLock.PORTRAIT_UP
            );
          }
        }}
      />
    </View>
  ) : (
    <View style={{ width: "100%", marginVertical: 5 }}>
      <VideoItem url={url} />
    </View>
  );
}
